<template>
  <d2-container>
    <el-button
      class="filter-item"
      type="primary"
      size="mini"
      icon="el-icon-circle-plus"
      @click="addCard"
    >添加</el-button>
    <el-table
      size="small"
      :key="tableKey"
      stripe
      border
      highlight-current-row
      style="margin-top: 20px"
      :data="keywordList"
    >
      <el-table-column align="center" label="id">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="名称">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="封面" align="center">
        <template slot-scope="scope">
          <img :src="scope.row.cover" style="width: 80px; height: 80px; object-fit: cover" />
        </template>
      </el-table-column>
      <el-table-column label="状态" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status === 0" >下架</el-tag>
          <el-tag v-if="scope.row.status === 1" type="success">上架</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="创建时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="更新时间">
        <template slot-scope="scope">
          <span>{{ scope.row.updateTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" fixed="right" width="120">
        <template slot-scope="scope">
          <el-button
            size="small"
            type="primary"
            @click="editCard(scope.row)"
            style="margin-top: 10px;"
          >编辑</el-button>
          <el-button
              size="small"
              type="primary"
              @click="updateStatus(scope.row.id, scope.row.status)"
              style="margin-top: 10px;"
          >{{scope.row.status === 0 ? '上架' : '下架'}}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 页码 -->
    <template slot="footer">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="listQuery.currentPage"
          :page-sizes="[10,20,30, 50]"
          :page-size="listQuery.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
      ></el-pagination>
    </template>
    <el-dialog :title="dialogStatus" :visible.sync="dialogFormVisible" width="30%">
      <el-form :model="form" :rules="rules" ref="form" label-width="80px">
        <el-form-item label="名称">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="封面">
          <upload-image v-model="form.cover" :max="1"></upload-image>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addOrUpdate()">确 定</el-button>
      </div>
    </el-dialog>
  </d2-container>
</template>
<script>

import {
  addWorkflowThemeCategory, downWorkflowThemeCategory,
  getWorkflowThemeCategoryList,
  updateWorkflowThemeCategory, upWorkflowThemeCategory
} from '@/api/merchant/service/project'
import UploadImage from '@/components/uploadImage/index.vue'

export default {
  name: 'comfyuiThemeClass',
  components: { UploadImage },
  data () {
    return {
      tableKey: 0,
      dialogStatus: '',
      textMap: {
        update: '编辑',
        create: '创建'
      },
      total: 0,
      keyWordManger_btn_add: false,
      keyWordManger_btn_edit: false,
      keyWordManger_btn_del: false,
      dialogFormVisible: false,
      keywordList: [],
      form: {
        id: '',
        name: '', // 名称
        cover: '' // 封面
      },
      listQuery: {
        currentPage: 1,
        pageSize: 20
      },
      listLoading: false,
      rules: {
        name: [
          {
            required: true,
            message: '分类名称',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 20,
            message: '长度在 1 到 20 个字符',
            trigger: 'blur'
          }
        ],
        cover: [
          {
            required: true,
            message: '请上传封面',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  created () {
    this.getSearch()
  },
  watch: {
  },
  methods: {
    updateStatus (id, status) {
      if (status === 0) {
        upWorkflowThemeCategory(id).then(res => {
          // 提示上架成功
          this.$message({
            message: '上架成功',
            type: 'success'
          })
          this.getSearch()
        })
      } else {
        downWorkflowThemeCategory(id).then(res => {
          // 提示下架成功
          this.$message({
            message: '下架成功',
            type: 'success'
          })
          this.getSearch()
        })
      }
    },
    // 每页条数
    handleSizeChange (val) {
      this.listQuery.pageSize = val
      this.getSearch()
    },
    // 当前页
    handleCurrentChange (val) {
      this.listQuery.currentPage = val
      this.getSearch(val)
    },
    getSearch (val) {
      let that = this
      if (val) {
        this.listQuery.currentPage = val
      } else {
        this.listQuery.currentPage = 1
      }
      getWorkflowThemeCategoryList(this.listQuery).then(
        res => {
          that.listLoading = true
          that.keywordList = res.records
          that.total = Number(res.total)
          that.listLoading = false
        },
        err => {
          console.log('res', err)
        }
      )
    },
    editCard (data) {
      this.dialogStatus = this.textMap.update
      this.dialogFormVisible = true
      this.form = data
    },
    addCard () {
      this.dialogStatus = this.textMap.create
      this.dialogFormVisible = true
      this.form = {
        id: '',
        name: '', // 名称
        cover: '' // 封面
      }
    },
    addOrUpdate () {
    //   验证表单
      this.$refs['form'].validate(valid => {
        if (this.form.id) {
          updateWorkflowThemeCategory(this.form).then(res => {
            this.$message({
              message: '修改成功',
              type: 'success'
            })
            this.dialogFormVisible = false
            this.getSearch()
          })
        } else {
          addWorkflowThemeCategory(this.form).then(res => {
            this.$message({
              message: '添加成功',
              type: 'success'
            })
            this.dialogFormVisible = false
            this.getSearch()
          })
        }
      })
    },
    cancel () {
      let that = this
      that.dialogFormVisible = false
    }
  }
}
</script>
<style scoped>
.span {
  width: 50px;
  height: 50px;
  display: block;
  margin: 0px auto;
  border: 1px solid rgba(0, 0, 0, 0.3);
}
</style>
